/**
 * BillingPage — Управление тарифами (для Super Admin)
 */
import { useState } from 'react';

export function BillingPage(): React.JSX.Element {
  const [prices, setPrices] = useState({
    pro: 2990,
    trial: 0,
    ai_extra: 990
  });

  return (
    <div className="p-1">
      <h1>💎 Тарифы и цены</h1>

      <div className="section-title">Стоимость подписок (₽)</div>

      <div className="card" style={{ marginBottom: '20px', gap: '15px' }}>
        <div>
          <label className="status-label">PRO План (в месяц)</label>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <input 
              type="number" 
              className="card-value" 
              style={{ background: 'none', border: 'none', color: 'var(--tg-text)', width: '120px' }}
              value={prices.pro}
              onChange={(e) => setPrices({...prices, pro: Number(e.target.value)})}
            />
            <span style={{ fontWeight: '800' }}>₽</span>
          </div>
        </div>

        <div>
          <label className="status-label">AI Ассистент (доп. опция)</label>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <input 
              type="number" 
              className="card-value" 
              style={{ background: 'none', border: 'none', color: 'var(--tg-text)', width: '120px' }}
              value={prices.ai_extra}
              onChange={(e) => setPrices({...prices, ai_extra: Number(e.target.value)})}
            />
            <span style={{ fontWeight: '800' }}>₽</span>
          </div>
        </div>
      </div>

      <button className="card" style={{ width: '100%', backgroundColor: 'var(--tg-btn)', color: 'white', alignItems: 'center' }}>
        <span className="card-label" style={{ color: 'white' }}>Сохранить новые цены</span>
      </button>

      <div className="section-title" style={{ marginTop: '30px' }}>Активные акции</div>
      <div className="booking-item">
        <div className="booking-info">
          <h4>Летний старт</h4>
          <p>Скидка 50% на первый месяц</p>
        </div>
        <div className="status-badge status-confirmed">Активна</div>
      </div>
    </div>
  );
}
